export const pluginPrefix = 'PLUGIN:TAF_CUSTOM:';
export const SELECTED_ENTITY_TYPE = `${pluginPrefix}SELECTED_ENTITY_TYPE`;
export const SET_GLOBAL_ENTITY_BY_TYPE = `${pluginPrefix}SET_GLOBAL_ENTITY_BY_TYPE`;
export const TOGGLE_APPLY_TAF_LOGIC = `${pluginPrefix}TOGGLE_APPLY_TAF_LOGIC`;
export const RESET_PRODUCT_DETAILS = `${pluginPrefix}SET_PRODUCT_DETAILS`;
export const TOOGLE_EDIT_MODE = `${pluginPrefix}TOOGLE_EDIT_MODE`;
export const SET_EDIT_STATE = `${pluginPrefix}SET_EDIT_STATE`;
export const RESET_EDIT_STATE = `${pluginPrefix}RESET_EDIT_STATE`;
export const SET_PRODUCTS_STATE = `${pluginPrefix}SET_PRODUCTS_STATE`;
export const SET_CUSTOMER_LAST_USED_ENTITIES = `${pluginPrefix}SET_CUSTOMER_LAST_USED_ENTITIES`;
export const DISPLAY_PREVIOUS_ENTITIES = `${pluginPrefix}DISPLAY_PREVIOUS_ENTITIES`;
export const SET_FIT_ID = `${pluginPrefix}SET_FIT_ID`;
